export default __webpack_public_path__ + "static/media/Snd_o3.83b7319d.mp3";